import React, { useEffect, useState } from 'react';
import { supabase } from '../supabase';
import { Link } from 'react-router-dom';
import ChitData from './ChitData';
import { Grid } from "react-loader-spinner";
import { useTranslation } from 'react-i18next';

class AuctionCard extends React.Component {
  render() {
    const auctionNumber = this.props.chit.next_installment_count;
    var options = { year: 'numeric', month: 'short', day: 'numeric', weekday: 'short' };
    let nextAuctionDateObject = new Date(this.props.chit.next_auction_date);
    const auctionDate = nextAuctionDateObject.toLocaleDateString("en-IN", options);

    return (
      <div className="flex max-w-sm rounded-md overflow-hidden shadow-lg px-6 py-4 bg-blue-300 mt-4 mx-auto">
        <div className="rounded-full h-6 w-6 flex items-center justify-center bg-blue-100 text-gray-800">{auctionNumber}</div>
        <div className="font-bold text-gray-800 text-base ml-4">{auctionDate}</div>
      </div>
    );
  }
}

class NextAuctionData extends React.Component {
  render() {
    return (
      <div className="flex flex-col">
        <div className="text-center">
          <h4 className="text-lg font-extrabold mt-8 tracking-normal">
            {this.props.t('text.nextAuction')}
          </h4>
        </div>
        <AuctionCard chit={this.props.chit} />
      </div>
    );
  }
}

class AuctionStatusBadge extends React.Component {
  render() {
    const won = this.props.won;

    if (won) {
      return <span className="bg-green-500 text-gray-200 text-xs mx-12 py-1 inline-block rounded-full font-semibold tracking-wide uppercase">
        {this.props.t('text.wonAuctionBadgeMessage')}
      </span>;
    }
    return "";
  }
}

class PastAuctionCard extends React.Component {
  render() {
    const t = this.props.t;
    const auction = this.props.auction;
    const auctionNumber = auction.auction_number;
    var options = { year: 'numeric', month: 'short', day: 'numeric', weekday: 'short' };
    let auctionDateObject = new Date(auction.auction_date);
    const auctionDate = auctionDateObject.toLocaleDateString("en-IN", options);
    const formatter = new Intl.NumberFormat(undefined, {
      style: 'currency',
      currency: 'INR',
      // These options are needed to round to whole numbers if that's what you want.
      minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
      maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
    });
    return (
      <div className="max-w-sm rounded-md overflow-hidden shadow-lg px-6 py-4 bg-blue-300 mt-4 mx-8">
        <div className="flex justify-center mb-2">
          <div className="rounded-full h-6 w-6 flex items-center justify-center bg-blue-100 text-gray-800">{auctionNumber}</div>
          <div className="font-bold text-gray-800 text-base ml-4">{auctionDate}</div>
        </div>
        <div className="flex flex-col text-center">
          <AuctionStatusBadge won={auction.has_won} t={t} />
        </div>
        <div className="flex flex-col text-center">
          <div className="flex-row mb-4">
            <p className="text-gray-700 text-base">
              {t('text.auctionAmount')}: <span className="text-gray-900">{formatter.format(auction.auction_amount)}</span>
            </p>
            <p className="text-gray-700 text-base">
              {t('text.winnerTook')}: <span className="rounded-md p-1 text-gray-800 bg-blue-200">
                {formatter.format(auction.winner_takes)}
              </span>
            </p>
            {
              auction.winner_name ?
                <p className="text-gray-700 text-base">
                  {t('text.winner')}: <span className="text-gray-900">
                    {auction.winner_name}
                  </span>
                </p> : ""
            }
            {
              auction.rem_members_pay ?
                <p className="text-gray-700 text-base">
                  {t('text.remMembersPaid')}: <span className="text-gray-900">{formatter.format(auction.rem_members_pay)}</span>
                </p> : ""
            }
            {
              auction.previous_winners_pay ?
                <p className="text-gray-700 text-base">
                  {t('text.prevWinnersPaid')}: <span className="text-gray-900">{formatter.format(auction.previous_winners_pay)}</span>
                </p> : ""
            }
          </div>
          <div className="flex-row">
            {
              auction.fee ?
                <p className="text-gray-700 text-base">
                  {t('text.fee')}: <span className="text-gray-900">{formatter.format(auction.fee)}</span>
                </p> : ""
            }
            {
              auction.expense ?
                <p className="text-gray-700 text-base">
                  {t('text.expense')}: <span className="text-gray-900">{formatter.format(auction.expense)}</span>
                </p> : ""
            }
            {
              auction.total_expenses ?
                <p className="text-gray-700 text-base">
                  {t('text.totalExpenses')}: <span className="text-gray-900">{formatter.format(auction.total_expenses)}</span>
                </p> : ""
            }
            {
              auction.commission ?
                <p className="text-gray-700 text-base">
                  {t('text.commission')}: <span className="text-gray-900">{formatter.format(auction.commission)}</span>
                </p> : ""
            }
          </div>
        </div>
        <Link to={`/chit/${this.props.chitId}/auction/${auction.id}/edit`}>
          <div className="flex flex-row justify-center mt-2">
            <button className="bg-blue-500 hover:bg-blue-700 text-gray-100 font-bold py-2 px-4 rounded-full inline-flex items-center">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2" viewBox="0 0 20 20" fill="currentColor">
                <path d="M17.414 2.586a2 2 0 00-2.828 0L7 10.172V13h2.828l7.586-7.586a2 2 0 000-2.828z" />
                <path fillRule="evenodd" d="M2 6a2 2 0 012-2h4a1 1 0 010 2H4v10h10v-4a1 1 0 112 0v4a2 2 0 01-2 2H4a2 2 0 01-2-2V6z" clipRule="evenodd" />
              </svg>
              <span>{t('button.editAuction')}</span>
            </button>
          </div>
        </Link>
      </div>
    );
  }
}

class SummaryCard extends React.Component {
  render() {
    const t = this.props.t;
    const formatter = new Intl.NumberFormat(undefined, {
      style: 'currency',
      currency: 'INR',
      // These options are needed to round to whole numbers if that's what you want.
      minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
      maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
    });
    const difference = this.props.wonAmount - this.props.totalAmountPaid;

    return (
      <div className="max-w-sm rounded-md overflow-hidden shadow-lg px-6 py-4 bg-blue-300 mt-4 mx-8">
        <div className="flex justify-center mb-2">
          <div className="flex flex-col text-center">
            <div className="flex-row">
              <p className="text-gray-700 text-base">
                {t('text.totalAmountPaid')}: <span className="text-gray-900">{formatter.format(this.props.totalAmountPaid)}</span>
              </p>
              {(this.props.wonAmount > 0) ?
                <p className="text-gray-700 text-base">
                  {t('text.wonAmount')}: <span className="text-gray-900">{formatter.format(this.props.wonAmount)}</span> ({formatter.format(difference)})
                </p> : ""
              }
            </div></div>
        </div></div>
    );
  }
}

class PastAuctionData extends React.Component {
  render() {
    const rows = [];
    this.props.pastAuctions.forEach(auction => {
      rows.push(
        <PastAuctionCard key={auction.id} chitId={this.props.chitId} auction={auction} t={this.props.t} />
      );
    });
    // Reversing the list to calculate summary card data
    let totalAmountPaid = 0;
    let hasWonAuction = false;
    let wonAmount = 0;
    this.props.pastAuctions.reverse();
    this.props.pastAuctions.forEach(auction => {
      if (auction.has_won) {
        hasWonAuction = true;
        wonAmount = auction.winner_takes;
      } else {
        totalAmountPaid += (hasWonAuction) ? auction.previous_winners_pay : auction.rem_members_pay;
      }
    });
    return (
      <div className="flex flex-col mb-4 mx-auto sm:max-w-xs">
        <div className="text-center">
          <h4 className="text-lg font-extrabold mt-8 tracking-normal">
            {this.props.t('text.summary')}
          </h4>
        </div>
        <SummaryCard totalAmountPaid={totalAmountPaid} wonAmount={wonAmount} t={this.props.t} />
        <div className="text-center">
          <h4 className="text-lg font-extrabold mt-8 tracking-normal">
            {this.props.t('text.completedAuctions')}
          </h4>
        </div>
        {rows}
      </div>
    );
  }
}

const ChitDetail = ({ match }) => {
  const { t } = useTranslation();
  const [chit, setChit] = useState({});
  const [errorText, setError] = useState("");
  const [pastAuctions, setPastAuctions] = useState([]);
  const [loadingChit, setLoadingChit] = useState(true);
  const [pastAuctionsFetchError, setPastAuctionsFetchError] = useState("");

  useEffect(() => {
    const fetchChit = async (id) => {
      let { data: chit, error } = await supabase
        .from("chits")
        .select("*")
        .eq('id', id)
        .single();
      if (error) {
        setError("No records found");
        setLoadingChit(false);
        console.log("error", error);
      } else {
        let nextAuctionDateObject = new Date(chit.next_auction_date);
        chit['next_auction_date_formatted'] = nextAuctionDateObject.toLocaleDateString('en-IN');
        setChit(chit);
        setLoadingChit(false);
      }
    }

    const fetchPastAuctions = async (id) => {
      let { data: pastAuctions, error } = await supabase
        .from("auctions")
        .select("*")
        .eq("chit_id", id)
        .order("auction_number", { ascending: false });
      if (error) {
        console.log("Error while fetching past auctions", error);
        setPastAuctionsFetchError(t('text.pastAuctionsFetchError'));
      } else {
        console.log(`Fetched ${pastAuctions.length} past auctions`);
        setPastAuctions(pastAuctions);
      }
    }

    fetchChit(match.params.chitId).catch(console.error);
    fetchPastAuctions(match.params.chitId).catch(console.error);
  }, [match, t]);

  const auctionLink = `/chit/${chit.id}/auction/add`;

  return (
    <div className="container flex flex-col">
      {
        loadingChit ?
          <div className="container flex px-4 py-4 mt-8 text-lg font-medium">
            <div className="mx-auto">
              <Grid type="Grid" color="#93C5FD" height="32" width="32" />
            </div>
          </div> :
          errorText ?
            <div className="container flex px-4 py-4 text-lg font-medium">
              <p className="mx-auto">{errorText}</p>
            </div> :
            <div>
              <ChitData chit={chit} t={t} />
              {!chit.is_completed ? <NextAuctionData chit={chit} t={t} /> : ""}
              {
                pastAuctionsFetchError &&
                <div className="flex flex-col mx-auto sm:max-w-xs"><div className="text-center">
                  <div className="text-red-600 text-s italic my-2">{pastAuctionsFetchError}</div>
                </div></div>
              }
              {(pastAuctions.length > 0) ? <PastAuctionData chitId={chit.id} pastAuctions={pastAuctions} t={t} /> : ""}
              {(!chit.is_completed) ?
                <Link to={auctionLink}>
                  <div className="fixed z-10 bottom-0 right-0 rounded-full flex items-center justify-center px-2 py-2 ml-4 mr-4 mt-8 mb-4 bg-blue-500 text-gray-900 shadow cursor-pointer bg-opacity-75 sm:relative sm:max-w-xs sm:mx-auto">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
                    </svg>
                  </div>
                </Link> : ""
              }
            </div>
      }
    </div>
  );
}

export default ChitDetail;
